import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import MarketingLink from 'core/modules/MarketingLink/MarketingLink';

function MarketingLetterboxTile({
  id, assets, clickUrl,
}) {
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const { _420x295, _890x295 } = assets;
  const imageToRender = (isMobileMQ && _420x295) ? _420x295 : _890x295;

  return (
    <MarketingLink
      url={clickUrl}
      className="mn_letterboxTile mn_marketingLetterboxTile"
      data-placement-id={id}
    >
      <img
        data-test="marketing-image"
        src={imageToRender}
        alt={assets.imageAlternateText}
      />
    </MarketingLink>
  );
}

export default MarketingLetterboxTile;
